import type React from "react";
import styles from "./index.module.scss";

type ToggleSelectorProps = {
  options: string[];
  selected: string;
  onChange: (value: string) => void;
};

const ToggleSelector: React.FC<ToggleSelectorProps> = ({ options, selected, onChange }) => {
  return (
    <div className={styles["toggle"]}>
      {options.map((label) => (
        <button
          key={label}
          className={`${styles["toggle__option"]} ${selected === label ? styles["selected"] : ""}`}
          onClick={() => onChange(label)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default ToggleSelector;
